import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  return typeof d === "object" ? d.msg || JSON.stringify(d) : String(d);
}

export const SPECIALTY_ICONS = {
  Cardiology: "Heart",
  Dermatology: "Sparkles",
  Pediatrics: "Baby",
  Orthopedics: "Bone",
  Neurology: "Brain",
  Gynecology: "Flower2",
  "General Physician": "Stethoscope",
  ENT: "Ear",
  Ophthalmology: "Eye",
  Dentistry: "Smile",
};

export const CITIES = [
  "Mumbai",
  "Delhi NCR",
  "Bengaluru",
  "Hyderabad",
  "Pune",
  "Chennai",
  "Kolkata",
  "Ahmedabad",
];

export function formatINR(n) {
  if (n == null) return "—";
  return `₹${Number(n).toLocaleString("en-IN")}`;
}
